import { fromJS, Map as ImmutableMap } from 'immutable';
import simpleReducer from '../common/utils/simple-reducer.js';
import { FORGOT_PASSWORD, RESET_PASSWORD, UPDATE_USER } from './action-types.js';
import { changePassword, createUser, loginUser } from './actions.js';
import {
  CHANGE_PASSWORD_FORM_NAME,
  FORGOT_PASSWORD_FORM_NAME,
  LOGIN_FORM_NAME,
  RESET_PASSWORD_FORM_NAME,
  SIGNUP_FORM_NAME,
  UPDATE_USER_FORM_NAME
} from './constants';

const emptyMap = ImmutableMap();

function loginUserRejected(state, { payload }) {
  if (payload.validationMessages) {
    return state.mergeDeep({
      errors: ImmutableMap(payload.validationMessages),
      data: {
        password: undefined
      }
    });
  }

  if (payload.message) {
    const errors = state.get('errors', emptyMap).set('password', payload.message);
    return state.mergeDeep({
      errors,
      data: {
        password: undefined
      }
    });
  }
}

function loginUserFulfilled(state) {
  return state.setIn(['data', 'password'], undefined);
}

function createUserRejected(state, action) {
  const { payload } = action;
  if (payload.name === 'ConflictError') {
    const errors = state.get('errors', emptyMap).set('email', payload.message);
    return state.mergeDeep({
      errors,
      data: {
        password: undefined
      }
    });
  }
}

function resetState() {
  return undefined;
}

function forgotPasswordRejected(state, { payload }) {
  if (payload.validationMessages) {
    return state.set('errors', ImmutableMap(payload.validationMessages));
  }

  if (payload.message) {
    const errors = state.get('errors', emptyMap).set('email', payload.message);
    return state.set('errors', errors);
  }
}

function changePasswordRejected(state, { payload }) {
  if (payload.validation) {
    return state.set('submitErrors', fromJS(payload.validation));
  }

  if (payload.message) {
    return state.setIn(['submitErrors', 'password'], payload.message);
  }
}

function changePasswordFulfilled(state) {
  return state.mergeDeep({
    submitted: false,
    data: {
      password: undefined,
      newPassword: undefined
    }
  });
}

function updateUserRejected(state, { payload }) {
  if (payload.statusCode === 409) {
    return state.setIn(['submitErrors', 'email'], payload.message);
  }

  if (payload.validation) {
    return state.set('submitErrors', fromJS(payload.validation));
  }

  return state;
}

function resetPasswordRejected(state, { payload }) {
  let errors;
  const { validationMessages } = payload;
  let { message } = payload;
  if (validationMessages) {
    errors = ImmutableMap(validationMessages);
  } else if (message) {
    if (message === 'Invalid auth token') {
      message =
        'Reset links are only valid for 30 minutes. You can try to log in again or resend a forgot password link.';
    }
  } else {
    message = 'Something has gone wrong. You can try to log in again or resend a forgot password link.';
  }

  errors ||= ImmutableMap({ password: message });

  return state.mergeDeep({
    errors,
    data: {
      password: undefined
    }
  });
}

export default {
  [LOGIN_FORM_NAME]: simpleReducer(ImmutableMap(), {
    [loginUser.REJECTED]: loginUserRejected,
    [loginUser.FULFILLED]: loginUserFulfilled
  }),
  [SIGNUP_FORM_NAME]: simpleReducer(ImmutableMap(), {
    [createUser.REJECTED]: createUserRejected,
    [createUser.FULFILLED]: resetState
  }),
  [FORGOT_PASSWORD_FORM_NAME]: simpleReducer(ImmutableMap(), {
    [`${FORGOT_PASSWORD}_REJECTED`]: forgotPasswordRejected,
    [`${FORGOT_PASSWORD}_FULFILLED`]: resetState
  }),
  [CHANGE_PASSWORD_FORM_NAME]: simpleReducer(ImmutableMap(), {
    [changePassword.FULFILLED]: changePasswordFulfilled,
    [changePassword.REJECTED]: changePasswordRejected
  }),
  [UPDATE_USER_FORM_NAME]: simpleReducer(ImmutableMap(), {
    [`${UPDATE_USER}_REJECTED`]: updateUserRejected
  }),
  [RESET_PASSWORD_FORM_NAME]: simpleReducer(ImmutableMap(), {
    [`${RESET_PASSWORD}_FULFILLED`]: resetState,
    [`${RESET_PASSWORD}_REJECTED`]: resetPasswordRejected
  })
};
